import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { BaseComponent } from '../../base.component';
import { CommonErrorResponse } from '../error.response';

@Component({
    templateUrl: './common.error.handler.modal.component.html',
    styleUrls: ['./common.error.handler.modal.component.scss']
})
export class CommonErrorHandlerModalComponent extends BaseComponent {
    constructor(private modalRef: MatDialogRef<CommonErrorHandlerModalComponent>,
                public errorResponse: CommonErrorResponse) {
        super();
    }

    public close(): void {
        this.modalRef.close();
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/error.modal/common.error.handler.modal/common.error.handler.modal.component.ts